<template>
  <div
    v-if="
      unidatoObject != undefined &&
        unidatoObject != null &&
        parentPath &&
        visible &&
        unidatoObject.behavior.isVisible
    "
    class="unidata-editor"
    :class="ready"
  >
    <div class="row mr-0">
      <div
        v-if="showLabel == 1 || (showLabel == -1 && unidatoObject.behavior.showLabel)"
        :class="templateConfiguration.label"
      >
        <label
          v-tooltip="uniToolTipTranslation(unidatoObject.label, 'en-US')"
          class="label-unidato"
          >{{ uniTranslation(unidatoObject.label) }}</label
        >

        <div v-if="inputValueChanged && dropdownUms.length != 0" style="float: right !important;">
          <label style="color:Red">! Recalc &nbsp;</label>
        </div>
      </div>
      <div
        v-if="
          showDropDown == 1 ||
            (showDropDown == -1 && dropdownUms && unidatoObject.behavior.showDropDown)
        "
        class="unidata-item-container"
        :class="templateConfiguration.um"
      >
        <el-select
          v-if="dropdownUms.length > 0"
          v-model="selectedUM"
          class="form-control select"
          :placeholder="uniTranslation('UM')"
          @change="changeSelectedUM"
        >
          <el-option
            v-for="item in dropdownUms"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <label
          style="margin-top: 4px;margin-left: 5px"
          v-if="dropdownUms.length == 0 && selectedUM == '%'"
          >%</label
        >
        <div v-if="inputValueChanged && dropdownUms.length == 0" style="float: right !important;">
          <label style="color:Red">! Recalc &nbsp; </label>
        </div>
      </div>

      <div :class="unidataEditorColumns">
        <div class="row">
          <div
            v-if="showInput == 1 || (showInput == -1 && templateConfiguration.input)"
            class="unidata-item-container"
            :class="overrideInputClass ? overrideInputClass : templateConfiguration.input"
          >
            <!-- || (showInput == -1 && unidatoObject.behavior.showInput) -->
            <VueAutonumeric
              v-if="unidatoObject.behavior.showInput"
              v-model="inputVal"
              class="form-control auto-numeric"
              :options="{
                allowDecimalPadding: false,
                digitGroupSeparator: '',
                decimalCharacter: ',',
                decimalPlaces: inputDecimalNum,
                decimalCharacterAlternative: '.',
                currencySymbol: '\u00a0€',
                currencySymbolPlacement: 's',
                roundingMethod: 'U',
                emptyInputBehavior: 'null',
                symbolWhenUnfocused: '',
                selectOnFocus: 'false',
                currencySymbol: '',
                negativePositiveSignPlacement: 'p'
              }"
              @blur="onBlur"
            >
            </VueAutonumeric>
          </div>

          <div
            v-if="showOutput2 == 1 || (showOutput2 == -1 && templateConfiguration.output2)"
            class="unidata-item-container"
            :class="overrideOutput2Class ? overrideOutput2Class : templateConfiguration.output2"
          >
            <!-- || (showInput == -1 && unidatoObject.behavior.showOutputBT) -->
            <VueAutonumeric
              v-if="unidatoObject.behavior.showOutputBT"
              v-model="termicBalanceOutput"
              disabled="true"
              class="form-control auto-numeric"
              :options="{
                allowDecimalPadding: false,
                digitGroupSeparator: '',
                decimalCharacter: ',',
                decimalPlaces: balanceDecimalNum,
                decimalCharacterAlternative: '.',
                currencySymbol: '\u00a0€',
                currencySymbolPlacement: 's',
                roundingMethod: 'U',
                emptyInputBehavior: 'null',
                symbolWhenUnfocused: '',
                currencySymbol: '',
                negativePositiveSignPlacement: 'p'
              }"
            ></VueAutonumeric>
          </div>

          <div
            v-if="showOutput1 == 1 || (showOutput1 == -1 && templateConfiguration.output1)"
            class="unidata-item-container"
            :class="overrideOutput1Class ? overrideOutput1Class : templateConfiguration.output1"
          >
            <!-- || (showInput == -1 && unidatoObject.behavior.showOutput) -->
            <VueAutonumeric
              v-if="unidatoObject.behavior.showOutput"
              v-model="verifyValueOutput"
              disabled="true"
              class="form-control auto-numeric"
              :style="inputStyle"
              :options="{
                allowDecimalPadding: false,
                digitGroupSeparator: '',
                decimalCharacter: ',',
                decimalPlaces: outputDecimalNum,
                decimalCharacterAlternative: '.',
                currencySymbol: '\u00a0€',
                currencySymbolPlacement: 's',
                roundingMethod: 'U',
                emptyInputBehavior: 'null',
                symbolWhenUnfocused: '',
                selectOnFocus: 'false',
                currencySymbol: '',
                negativePositiveSignPlacement: 'p'
              }"
            ></VueAutonumeric>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from "axios";
import VueAutonumeric from "../shared/VueAutonumeric";
import jsonHelper from "../../shared/jsonHelper";
import templateHelper from "../../shared/templateHelper";
import { mapGetters } from "vuex";
import { Select, /*Input,*/ Option } from "element-ui";
import conversionService from "../../services/backend/conversionService";
import umService from "../../services/backend/umService";
export default {
  components: {
    VueAutonumeric,
    "el-select": Select,
    "el-option": Option
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    fixedDecimals: {
      type: Number,
      required: false,
      default: -1
    },
    autoDecimals: {
      type: Number,
      required: false,
      default: -1
    },
    showInput: {
      type: Number,
      required: false,
      default: -1
    },
    overrideInputClass: {
      type: String,
      required: false,
      default: undefined
    },
    showOutput1: {
      type: Number,
      required: false,
      default: -1
    },
    overrideOutput1Class: {
      type: String,
      required: false,
      default: undefined
    },
    showOutput2: {
      type: Number,
      required: false,
      default: -1
    },
    overrideOutput2Class: {
      type: String,
      required: false,
      default: undefined
    },
    showLabel: {
      type: Number,
      required: false,
      default: -1
    },
    showDropDown: {
      type: Number,
      required: false,
      default: -1
    },
    unidataEditorColumns: {
      type: String,
      required: false,
      default: "col-4"
    },
    validateUsrValue: {
      type: Boolean,
      required: false,
      default: false
    },
    correlatedFields: {
      type: Array,
      required: false,
      default: () => []
    },
    umShow: {
      type: String,
      required: false,
      default: null
    },
    umNotShow: {
      type: String,
      required: false,
      default: null
    },
    inputStyle: {
      type: String,
      required: false
    },
    min: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      unidatoObject: null,
      visible: true,
      inputVal: 0.0,
      verifyValueOutput: 0,
      termicBalanceOutput: 0,
      selectedUM: null,
      referenceUM: null,
      dropdownUms: [],
      umDecimalNum: -1,
      roundingMethod: "D",
      ready: "loading",
      inputValueChanged: false
    };
  },
  computed: {
    ...mapGetters(["projects", "umsDictionary"]),
    templateConfiguration() {
      return this.getTemplateConfig();
    },
    order() {
      if (this.unidatoObject == null) return 9999;
      return this.unidatoObject.order;
    },
    inputDecimalNum() {
      if (this.fixedDecimals != -1) {
        return this.fixedDecimals;
      }
      if (this.umDecimalNum != -1) {
        return this.umDecimalNum;
      }
      return 8;
    },
    balanceDecimalNum() {
      if (this.fixedDecimals != -1) {
        return this.fixedDecimals;
      }
      if (this.autoDecimals != -1) {
        return this.getAutoDecimals(this.autoDecimals, this.termicBalanceOutput);
      }
      if (this.umDecimalNum != -1) {
        return this.umDecimalNum;
      }
      return 8;
    },
    outputDecimalNum() {
      if (this.fixedDecimals != -1) {
        return this.fixedDecimals;
      }
      if (this.autoDecimals != -1) {
        return this.getAutoDecimals(this.autoDecimals, this.verifyValueOutput);
      }
      if (this.umDecimalNum != -1) {
        return this.umDecimalNum;
      }
      return 8;
    }
  },
  destroyed: function() {
    this.unsubscribe();
  },
  mounted: function() {
    if (this.parentPath != undefined && this.parentPath != null && this.parentPath != "") {
      this.path = this.parentPath + this.name;
      this.unidatoObject = jsonHelper.getProperty(this.projects, this.path);
    }
    var that = this;

    // alert(that.path + " >> " + JSON.stringify(that.unidatoObject));

    if (that.unidatoObject) {
      if (that.unidatoObject.category) {
        var lista = [];
        var key = (that.unidatoObject.category + "").toLowerCase();
        if (Object.keys(that.umsDictionary).includes(key)) {
          lista = that.umsDictionary[key];
        }
        that.setUmsList(lista);
        /*var lista = that.$store.getters.getListByCate(that.unidatoObject.category);
        if (lista == null) {
          umService.getUms(that.unidatoObject.category).then(function(data) {
            that.$store.commit("impostaUms", { cate: that.unidatoObject.category, listaUM: data });
            that.setUmsList(data);
          });
        } else {
          that.setUmsList(lista);
        }*/
      } else {
        /*
        if (that.fixedDecimals != -1) {
          that.decimalNum = that.fixedDecimals;
        }
        */
        that.ready = "";
        that.inputVal = that.unidatoObject.input.usrValue.value;
        that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
        that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
      }
    }

    this.unsubscribe = this.$store.subscribe(function(mutation /*, state*/) {
      if (mutation.type === "changeProjectPropertyInternal") {
        if (mutation.payload.path.startsWith(that.path)) {
          that.unidatoObject = jsonHelper.getProperty(that.projects, that.path);
          if (that.unidatoObject) {
            /*that.inputVal = that.unidatoObject.input.usrValue.value;
            that.referenceUM = that.unidatoObject.input.refValue.um;
            that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
            that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
            that.selectedUM = that.unidatoObject.input.usrValue.um;*/
            // that.verifyValueOutput = that.unidatoObject.output.refValue.value;
            //alert(that.path);
            that.converti(true);
          }
        }
      }
      if (mutation.type === "changeProjectProperty") {
        if (mutation.payload.path.startsWith(that.path)) {
          that.unidatoObject = jsonHelper.getProperty(that.projects, that.path);
          if (that.unidatoObject) {
            that.inputVal = that.unidatoObject.input.usrValue.value;
            that.referenceUM = that.unidatoObject.input.refValue.um;
            that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
            that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
            that.selectedUM = that.unidatoObject.input.usrValue.um;
          }
        }
      }
      if (mutation.type === "refreshAll" || mutation.type === "refreshAllData") {
        that.unidatoObject = jsonHelper.getProperty(that.projects, that.path);
        if (that.unidatoObject) {
          console.log(mutation.type + " > " + that.uniTranslation(that.unidatoObject.label));
          that.inputVal = that.unidatoObject.input.usrValue.value;
          that.referenceUM = that.unidatoObject.input.refValue.um;
          that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
          that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
          that.selectedUM = that.unidatoObject.input.usrValue.um;
        }
      }
    });

    // umService.getUms(this.category).then(function(data) {
    //   data.forEach(element => {
    //     that.dropdownUms.push({
    //       value: element.id,
    //       label: element.descrizione,
    //       decimals: element.decimals
    //     });
    //   });
    // });
  },
  methods: {
    setUmsList(data) {
      var that = this;
      data.forEach(element => {
        var bAddMisura = true;

        if (that.umShow != null) {
          bAddMisura = that.umShow.includes(element.descrizione);
        } else {
          bAddMisura = true;
        }
        console.log(that.umNotShow);
        if (that.umNotShow != null) {
          bAddMisura = !that.umNotShow.includes(element.descrizione);
        } else {
          bAddMisura = true;
        }
        if (bAddMisura) {
          that.dropdownUms.push({
            value: element.id,
            label: element.descrizione,
            decimals: element.decimals
          });
        }
      });
      var um = that.unidatoObject.input.usrValue.um;
      if (um != undefined) that.setUM(um);
      that.ready = "";
      that.inputVal = that.unidatoObject.input.usrValue.value;
      that.verifyValueOutput = that.unidatoObject.output.usrValue.value;
      that.termicBalanceOutput = that.unidatoObject.outputBilancio.usrValue.value;
      that.referenceUM = that.unidatoObject.input.refValue.um;
    },

    onBlur: function() {
      // var oldInputVal = jsonHelper.getProperty(this.projects, this.path + ".input.usrValue.value");

      var that = this;

      var unidato = jsonHelper.getProperty(that.projects, that.path);

      var bEseguiValidate = true;

      if (unidato.input.usrValue.value && that.inputVal) {
        if (
          unidato.input.usrValue.value.toFixed(that.inputDecimalNum) ==
          that.inputVal.toFixed(that.inputDecimalNum)
        ) {
          bEseguiValidate = false;
        }
      }

      if (this.min != null) {
        this.inputVal = Math.max(this.min, this.inputVal);
      }

      that.$store.dispatch("changeProjectProperty", {
        path: that.path + ".input.usrValue.value",
        value: that.inputVal
      });

      that.$store.dispatch("changeProjectProperty", {
        path: that.path + ".input.refValue.value",
        value: that.inputVal
      });
      that.$store.dispatch("changeProjectProperty", {
        path: that.path + ".input.refValue.um",
        value: that.selectedUM
      });

      // var unidato = jsonHelper.getProperty(that.projects, that.path);
      //var prjName = that.path.substring(0, that.path.indexOf("."));

      if (bEseguiValidate) {
        if (that.validateUsrValue) {
          conversionService
            .validateUsrValue({
              unidato: unidato,
              project: this.GetSimplexProject(), //that.projects[prjName],
              path: that.name
            })
            .then(function(data) {
              that.$store.dispatch("changeProjectProperty", {
                path: that.path + ".input.usrValue.value",
                value: data.input.usrValue.value
              });
              that.inputValueChanged = data.inputValueChanged;
            })
            .catch(function() {
              //that.$store.commit("abilitaCalcola");
            });
        }

        if (that.correlatedFields) {
          if (that.correlatedFields.length > 0) {
            that.$store.commit("disabiltaCalcola");
            conversionService
              .correlateValues({
                unidato: unidato,
                project: this.GetSimplexProject(), //that.projects[prjName],
                path: that.name,
                correlatedFields: that.correlatedFields
              })
              .then(function(data) {
                if (data != null) {
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].unidato != null) {
                      that.$store.dispatch("changeProjectProperty", {
                        path: that.parentPath + data[i].name,
                        value: data[i].unidato
                      });
                    }
                  }
                }
                that.$store.commit("abilitaCalcola");
              })
              .catch(function() {
                that.$store.commit("abilitaCalcola");
              });
          }
        }

        that.$store.dispatch("userInputChanged", {
          path: that.path + ".input.usrValue.value",
          value: that.inputVal
        });
      }
    },
    setUM: function(newUM) {
      var that = this;
      this.selectedUM = newUM;
      this.dropdownUms.forEach(function(Um) {
        if (Um.value == that.selectedUM) {
          that.umDecimalNum = Um.decimals;
        }
      });
      /*
      if (that.fixedDecimals != -1) {
        that.decimalNum = that.fixedDecimals;
      } else {
        this.dropdownUms.forEach(function(Um) {
          if (Um.value == that.selectedUM) {
            that.decimalNum = Um.decimals;
          }
        });
      }
      */
    },
    getTemplateConfig: function() {
      return templateHelper.getTemplateConfiguration(
        this.unidatoObject.behavior.templateConfiguration
      );
    },

    converti(byPassDispatch) {
      var that = this;
      that.dropdownUms.forEach(function(Um) {
        if (Um.value == that.selectedUM) {
          that.umDecimalNum = Um.decimals;
        }
      });
      /*
      if (that.fixedDecimals != -1) {
        that.decimalNum = that.fixedDecimals;
      } else {
        that.dropdownUms.forEach(function(Um) {
          if (Um.value == that.selectedUM) {
            that.decimalNum = Um.decimals;
          }
        });
      }
      */

      if (!byPassDispatch) {
        that.$store.dispatch("changeProjectProperty", {
          path: that.path + ".input.usrValue.um",
          value: that.selectedUM
        });
        that.$store.dispatch("changeProjectProperty", {
          path: that.path + ".output.usrValue.um",
          value: that.selectedUM
        });
        that.$store.dispatch("changeProjectProperty", {
          path: that.path + ".outputBilancio.usrValue.um",
          value: that.selectedUM
        });
      }

      var unidato = jsonHelper.getProperty(that.projects, that.path);

      //var prjName = that.path.substring(0, that.path.indexOf("."));
      conversionService
        .convertUnidatoRefUsr({
          unidato: unidato,
          project: this.GetSimplexProject(), //that.projects[prjName],
          path: that.path
        })
        .then(function(data) {
          console.log(data.input.usrValue.value);
          that.$store.dispatch("changeProjectProperty", {
            path: that.path + ".input.usrValue.value",
            value: data.input.usrValue.value
          });
          that.$store.dispatch("changeProjectProperty", {
            path: that.path + ".output.usrValue.value",
            value: data.output.usrValue.value
          });
          that.$store.dispatch("changeProjectProperty", {
            path: that.path + ".outputBilancio.usrValue.value",
            value: data.outputBilancio.usrValue.value
          });
        });
    },

    setValue(newValue, rifUm) {
      var that = this;
      console.log(newValue + "" + rifUm);
      that.$store.dispatch("changeProjectProperty", {
        path: that.path + ".input.refValue.value",
        value: newValue
      });
      that.$store.dispatch("changeProjectProperty", {
        path: that.path + ".input.refValue.um",
        value: rifUm
      });
      that.$store.dispatch("changeProjectProperty", {
        path: that.path + ".output.refValue.value",
        value: newValue
      });
      that.$store.dispatch("changeProjectProperty", {
        path: that.path + ".output.refValue.um",
        value: rifUm
      });
      that.converti(true);
    },

    changeSelectedUM: function() {
      var that = this;
      var oldUm = jsonHelper.getProperty(that.projects, that.path + ".input.usrValue.um");

      if (that.selectedUM !== oldUm) {
        that.converti(false);
      }
    },

    getAutoDecimals: function(maxDec, value) {
      if (value < 10) {
        return Math.min(maxDec, 8);
      }
      if (value < 1000) {
        return Math.min(maxDec, 2);
      }
      return Math.min(maxDec, 0);
    },

    GetSimplexProject() {
      var prjName = this.path.substring(0, this.path.indexOf("."));
      var P = this.projects[prjName];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      deepClone_P.innerProject = null;
      deepClone_P.selectionOutput.selectionOutput = [];
      deepClone_P.results = [];
      return deepClone_P;
    }
  }
};
</script>

<style lang="scss">
$input-height: 30px;

.unidata-editor {
  background-color: transparent;
  margin: 0 0 0px 0px !important;
  //padding: 10px 0;
  width: 100%;
  outline: none;

  .unidata-item-container {
    border: none;
    height: $input-height !important;
    padding: 0 0px;

    .select {
      border: none;
    }

    .form-control {
      padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.auto-numeric {
        padding: 0 5px;
        text-align: center;
      }

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}
.label-unidato {
  margin-top: 9px;
  margin-bottom: 0px;
}

.loading {
  opacity: 0.3;
}
</style>
